var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",attrs:{"get-payload":_vm.payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }